import { useParams } from 'react-router-dom'
import React from 'react'
import { com } from '@eidu/web'
import ManageEntityTypePage from '../ManageEntityTypePage'
import entityTypeIdFromString = com.eidu.sharedlib.entity.type.entityTypeIdFromString

export const ConfigurePageRoute = () => {
  const params = useParams()

  if (params.entityTypeId) return <ManageEntityTypePage entityTypeId={entityTypeIdFromString(params.entityTypeId)} />
  else return <ManageEntityTypePage entityTypeId={undefined} />
}

export default ConfigurePageRoute
